const initAnnouncement = (section) => {
	const announcementBar = section.querySelector(".announcement-bar.swiper");
	if (!announcementBar) return;

	// Prevent duplicate init (Shopify editor reload fix)
	if (announcementBar.swiper) {
		announcementBar.swiper.destroy(true, true);
	}

	const speed = (announcementBar.dataset.speed || 2) * 700;
	const delay = (announcementBar.dataset.delay || 3) * 700;

	const prevBtn = section.querySelector(".announcement-prev");
	const nextBtn = section.querySelector(".announcement-next");

	// Set initial opacity
	const setSlideOpacity = (swiper) => {
		swiper.slides.forEach((slide, index) => {
			if (index === swiper.activeIndex) {
				slide.style.opacity = "1";
			} else {
				slide.style.opacity = "0";
			}
		});
	};

	const swiper = new Swiper(announcementBar, {
		loop: true,
		slidesPerView: 1,
		speed: speed,
		spaceBetween: 0,

		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},

		autoplay: {
			delay: delay,
			disableOnInteraction: false,
		},

		navigation: {
			prevEl: prevBtn,
			nextEl: nextBtn,
		},

		on: {
			init(swiper) {
				setSlideOpacity(swiper);
			},
			slideChange(swiper) {
				setSlideOpacity(swiper);
			},
		},
	});
};

// Initial load
document.addEventListener("DOMContentLoaded", () => {
	initAnnouncement(document);
});

// Shopify editor reload
document.addEventListener("shopify:section:load", (event) => {
	initAnnouncement(event.target);
});